import { useView } from '../app/use-view.ts'
import styles from './eyelids.module.css'

/**
 * The player's eyelids over the whole screen: they close as the player falls asleep and open
 * as they wake, over the engine's `seconds`. Under reduced motion the screen fades instead.
 * When the engine asks for a `fade` (a shower, the toilet), a black veil fades in and out
 * and the lids stay open.
 */
export function Eyelids() {
  const closed = useView((view) => view.hud.eyelids.closed)
  const seconds = useView((view) => view.hud.eyelids.seconds)
  const fade = useView((view) => view.hud.eyelids.fade)
  const duration = { transitionDuration: `${String(seconds)}s` }
  return (
    <>
      <div
        class={styles.eyelids}
        data-closed={(closed && !fade) || undefined}
        style={duration}
        aria-hidden="true"
      >
        <div class={styles.lid} data-edge="top" style={duration} />
        <div class={styles.lid} data-edge="bottom" style={duration} />
      </div>
      <div
        class={styles.veil}
        data-closed={(closed && fade) || undefined}
        style={duration}
        aria-hidden="true"
      />
    </>
  )
}
